var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2595 11.1267L37.4058 24.5726C37.7264 24.7673 37.7264 25.2327 37.4058 25.4274L15.2595 38.8733C14.9263 39.0757 14.5 38.8358 14.5 38.446V11.554C14.5 11.1642 14.9263 10.9243 15.2595 11.1267Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2595 11.1267L37.4058 24.5726C37.7264 24.7673 37.7264 25.2327 37.4058 25.4274L15.2595 38.8733C14.9263 39.0757 14.5 38.8358 14.5 38.446V11.554C14.5 11.1642 14.9263 10.9243 15.2595 11.1267Z",
    stroke: "url(#paint0_linear_576_6281)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_576_6281",
    x1: 27,
    y1: 8,
    x2: 27,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCardIcon);
export default __webpack_public_path__ + "static/media/Play_Card_icon.611b24647440b1138341799ed9894282.svg";
export { ForwardRef as ReactComponent };